export var inputs = {};
export var inputLabels = {};
export function isTabbable(node) {
  return ['BUTTON', 'INPUT'].indexOf(node.tagName) > -1 || parseInt(node.getAttribute('tabindex'), 10) > -1;
}